/* EternalBond — motion system (GSAP + ScrollTrigger when available, CSS-only fallback otherwise) */
(function () {
  var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Motion tokens — keep numeric values in sync with --eb-dur-* in eb-hero.liquid */
  var EB_MOTION = {
    micro: 0.2,
    standard: 0.55,
    editorial: 0.9,
    cinematic: 1.3,
    ease: 'power3.out',
    easeInOut: 'power2.inOut'
  };
  window.EB_MOTION = EB_MOTION;

  function revealAllInstant() {
    document.querySelectorAll('.eb-reveal').forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  var hasGSAP = !!window.gsap;
  var hasScrollTrigger = hasGSAP && !!window.ScrollTrigger;

  if (hasScrollTrigger) {
    gsap.registerPlugin(ScrollTrigger);
  }

  /* Reduced motion or missing GSAP: show everything at rest, no scroll choreography */
  if (prefersReduced || !hasScrollTrigger) {
    document.addEventListener('DOMContentLoaded', revealAllInstant);
    revealAllInstant();
    return;
  }

  function initReveals() {
    var els = document.querySelectorAll('.eb-reveal:not(.is-visible)');
    if (!els.length) return;
    ScrollTrigger.batch(els, {
      start: 'top 88%',
      once: true,
      onEnter: function (batch) {
        batch.forEach(function (el, i) {
          gsap.delayedCall(i * 0.09, function () {
            el.classList.add('is-visible');
          });
        });
      }
    });
  }

  /* Hero: media drifts into a slow zoom, content eases up and out — transform/opacity only */
  function initHero() {
    var hero = document.querySelector('[data-eb-hero]');
    if (!hero) return;
    var media = hero.querySelector('[data-eb-hero-media]');
    var content = hero.querySelector('[data-eb-hero-content]');

    if (media) {
      gsap.fromTo(
        media,
        { scale: 1 },
        {
          scale: 1.14,
          ease: 'none',
          scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: 0.4 }
        }
      );
    }
    if (content) {
      gsap.to(content, {
        y: -60,
        opacity: 0.15,
        ease: 'none',
        scrollTrigger: { trigger: hero, start: 'top top', end: '75% top', scrub: 0.4 }
      });
    }
  }

  /* Editorial / category images: gentle scrub parallax, transform only */
  function initParallax() {
    document.querySelectorAll('[data-eb-parallax]').forEach(function (el) {
      gsap.fromTo(
        el,
        { yPercent: -8 },
        {
          yPercent: 8,
          ease: 'none',
          scrollTrigger: {
            trigger: el.closest('.eb-editorial__media') || el.parentElement || el,
            start: 'top bottom',
            end: 'bottom top',
            scrub: 0.6
          }
        }
      );
    });
  }

  function init() {
    initReveals();
    initHero();
    initParallax();
    ScrollTrigger.refresh();
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', function () {
    init();
  });
})();
